import catalog from "../data/publicVerifiedAddresses.json";
import { saveVerifiedAddresses } from "./verifiedAddressStorage";

// This scope is a public, device-local queue. It is not a Firebase user ID and
// never reads or publishes a signed-in user's private browser-storage entries.
export const PUBLIC_ADDRESS_POOL_ID = "public-get-address";

export const getPublishedVerifiedAddresses = () => {
  if (catalog.version !== 1 || !Array.isArray(catalog.items) || !catalog.items.length) {
    throw new Error("The public confirmed-address list is unavailable.");
  }
  return catalog.items.map(row => ({ ...row }));
};

export const initializePublicAddressPool = () => {
  // Replacing the catalog preserves used physical-address keys and the last
  // issued address, so reloading the public page cannot issue the same one again.
  return saveVerifiedAddresses(PUBLIC_ADDRESS_POOL_ID, getPublishedVerifiedAddresses(), { replace: true });
};
